import React, { useEffect } from "react";
import { Center } from "../../../styles/component/style";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import moment from "moment";
import { navigate, useLocation, useParams } from "@reach/router";
import { getErrorMessage } from "../../../helpers/functions";
import ViewerService from "../../../services/ViewerService";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { Header } from "../Header/Header";
import Footer from "../Header/Footer";
// import VideoBox from "../../common/VideoBox";

/*

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: 20,
  },
  paper: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "20px",
    marginBottom: "20px",
    height: "23vh",
    width: "55%",
    noWrap: true,
    backgroundColor: "#ffffff",
    // fontFamily: theme.fonts.primaryFontRegular,
    "@media (max-width:1024px)": {
      width: "55%",
    },

    "@media (max-width:700px)": {
      margin: "20px 30px",
      width: "auto",
      textAlign: "left",
    },
  },
  image: {
    width: 250,
    height: 200,
    paddingLeft: "20px",
    paddingTop: "4px",
    "@media (max-width:700px)": {
      height: "unset",
      maxHeight: 200,
    },
  },
  img: {
    display: "block",
    maxWidth: "100%",
    maxHeight: 200,
    borderRadius: "2.5%",
    justify: "center",
    margin: "auto",
    "@media (max-width:700px)": {
      margin: 0,
    },
  },
  list: {
    listStyleType: "none",
    marginRight: "5px",
    fontSize: "16px",
  },
  button: {
    marginTop: "1rem",
    fontSize: "14px",
    backgroundColor: COLORS.BTN_GREEN,
    textAlign: "left",
    "&:hover": { backgroundColor: COLORS.BTN_GREEN },
  },
  name: {
    fontFamily: "openSans-SemiBold",
    src: "../../assets/fonts/OpenSans-SemiBold.ttf",
    padding: "5px",
    paddingLeft: "0",
    fontSize: "18px",
    color: "#00aeef",
    "@media (max-width:700px)": {
      fontSize: "18px",
    },
  },
  padder: {
    paddingTop: "5px",
  },
  lastPosition: {
    color: "gray",
    paddingTop: "5px",
  },
  container: {
    margin: "25px",
  },
}));

*/

const ViewerDashboard = () => {
  // const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { orgId } = useParams();
  const [cards, setCards] = useState();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  let customisedSignIn = searchParams.get("customisedSignIn");
  let findeId = location.pathname.lastIndexOf("/");
  let eventId = location.pathname.substring(findeId + 1);

  useEffect(() => {
    async function priorEventLandingPage(orgId, eventId) {
      try {
        const time = moment(new Date()).format("HH:mm");
        const response = await ViewerService.priorEventLandingPage(
          orgId,
          eventId,
          time,
        );
        setCards(response?.eventDetails);
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      }
    }
    if (orgId && eventId) {
      priorEventLandingPage(orgId, eventId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId, eventId]);

  useEffect(() => {
    const interval = setInterval(() => {
      (async function priorEventLandingPage() {
        try {
          const time = moment(new Date()).format("HH:mm");
          const response = await ViewerService.priorEventLandingPage(
            orgId,
            eventId,
            time,
          );
          setCards(response?.eventDetails);
        } catch (error) {
          const message = getErrorMessage(error);
          enqueueSnackbar(message, {
            variant: "error",
          });
        }
      })();
    }, 2000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  /*

  const formatedTime = (time) => {
    // Format the date with AM/PM in the specified format

    time = moment(time, "HH:mm:ss");

    const formattedTimeUppercase = moment(`${time}`).format("hh:mm A");
    // Custom format for output
    const formattedOutput = `${formattedTimeUppercase}`;
    return formattedOutput;
  };

  

  const Cards = [
    {
      Icon: (
        <ImageWrap
          className={classes.img}
          src={require("../../../assets/images/Asset 2@4x-100.jpg")}
        />
      ),
      title: cards?.eventName,
      description: cards?.eventDescription,

      registerButton: true,
      joinButton: true,
      date: cards?.date,
      time: formatedTime(cards?.startTime),
    },
  ];

  */

  const handleRegister = () => {
    if (cards?.registerStatus === "Completed") {
      enqueueSnackbar("Event Prior Registration has ended", {
        variant: "error",
      });
    } else if (cards.registerStatus === "Upcoming") {
      enqueueSnackbar("Prior Registration for the event not yet started", {
        variant: "error",
      });
    } else if (cards?.registerStatus === "EventCompleted") {
      enqueueSnackbar("Event has already ended", {
        variant: "error",
      });
    } else {
      navigate(`/priorRegister/register`, {
        state: {
          location: location?.href,
          orgId: orgId,
          eventId: eventId,
          customisedSignIn: customisedSignIn,
          otpValidation: cards.otpValidation,
          eventName: cards.eventName,
        },
      });
    }
  };

  const handleJoin = () => {
    if (cards?.eventStatus === "Completed") {
      enqueueSnackbar("Event has already ended", {
        variant: "error",
      });
    } else if (cards.eventStatus === "Upcoming") {
      enqueueSnackbar("Event not yet started", {
        variant: "error",
      });
    } else {
      navigate(`/priorRegister/sign-in`, {
        state: {
          location: location?.href,
          orgId: orgId,
          eventId: eventId,
          customisedSignIn: customisedSignIn,
        },
      });
    }
  };

  return (
    <Header>
      <div style={{ height: "92vh" }} className="gradient-background">
        <Center className="gradient-background">
          {/* <Container>
            <HeadingContainer>
              <Header3>{cards?.eventName}</Header3>
            </HeadingContainer>
            <Title>
              Join our industry insights and best practice advice.
              <p>Live and on-demand</p>
            </Title>
            <BodyWrap>
              {Cards.map((card) => (
                <ContentBox>
                  {card.Icon}
                  <TextWrap>
                    <div>{card.title}</div>
                    <Light>{card.description}</Light>
                    <DateTime>
                      <Iconfixed>
                        <Icon
                          src={require("../../../assets/images/Asset 5.svg")}
                          alt="submit"
                        />
                        {convertDateFormat(card.date)}
                      </Iconfixed>
                      <Iconfixed>
                        <Icon
                          src={require("../../../assets/images/Asset 6.svg")}
                          alt="submit"
                        />
                        {card.time}
                      </Iconfixed>
                    </DateTime>
                    <FormControl>
                      <Row>
                        {card.registerButton && (
                          <PrimaryCTAButton
                            onClick={handleRegister}
                            style={{
                              width: "47%",
                              marginRight: "12px",
                              padding: "5px 0px",
                            }}
                          >
                            {"Register"}
                          </PrimaryCTAButton>
                        )}
                        {card.joinButton && (
                          <PrimaryCTAButton
                            onClick={handleJoin}
                            style={{ width: "47%", padding: "5px 0px" }}
                          >
                            {"Join"}
                          </PrimaryCTAButton>
                        )}
                      </Row>
                    </FormControl>
                  </TextWrap>
                </ContentBox>
              ))}
            </BodyWrap>
          </Container> */}
          <Container>
            <Title>Event Title</Title>
            <Date>November 20, 2024</Date>
            <VideoContainer>
              Event
              {/* <VideoCard>
                <VideoBox
                  src={
                    "https://www.youtube.com/embed/Ra5eZIe5_80?rel=0&showinfo=0&start=0"
                  }
                />
              </VideoCard> */}
            </VideoContainer>
            <ButtonGroup>
              <Button onClick={handleRegister}>Register</Button>
              <Button onClick={handleJoin}>Sign-In</Button>
            </ButtonGroup>
            <Content>
              <p>
                Contrary to popular belief, Lorem Ipsum is not simply random
                text. It has roots in a piece of classical Latin literature from
                45 BC, making it over 2000 years old. Richard McClintock, a
                Latin professor at Hampden-Sydney College in Virginia, looked up
                one of the more obscure Latin words, consectetur, from a Lorem
                Ipsum passage, and going through the cites of the word in
                classical literature, discovered the undoubtable source.
              </p>
              <br />
              <p>
                Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de
                Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by
                Cicero, written in 45 BC. This book is a treatise on the theory
                of ethics, very popular during the Renaissance. The first line
                of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a
                line in section 1.10.32.
              </p>
            </Content>
          </Container>
        </Center>
      </div>
      <Footer />
    </Header>
  );
};

export default ViewerDashboard;

export const Container = styled.div`
  width: 60%;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  font-family: Arial, sans-serif;
  color: #6d0e52;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: bold;
  margin: 10px 0;
`;

const Date = styled.p`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  color: #6d0e52;
`;

const VideoContainer = styled.div`
  background-color: #00a0ff;
  color: white;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  margin: 20px 0;
  border-radius: 10px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 20px 0;
`;

const Button = styled.button`
  padding: 8px 20px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: white;
  background-color: #6d0e52;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

const Content = styled.div`
  text-align: left;
  font-family: ${theme.fonts.primaryFontSemiBold};
  fontsize: 14px;
  lineheight: 1.6;
  color: #333;
`;

export const Light = styled.div`
  margin-top: 8px;
  font-size: 14px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.COLOR_DARK};
`;

export const FormControl = styled.div`
  margin-bottom: 13px;
  @media ${theme?.breakpoints?.sm_up} {
    width: 236px;
    margin-top: 8px;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
`;

export const DateTime = styled.div`
  margin-top: 8px;
  font-size: 14px;
  display: flex;
  width: 216px;
  justify-content: space-between;
  font-family: ${theme.fonts.primaryFontRegular};
  color: ${COLORS.COLOR_DARK};
`;
